var objDataCenter = {
    // <summary>
    // This object holds everything regarding the data center stuff in the vcMenuTemplate
    // </summary>

    _initDcFeatureSelection: function (me) {
        /// <summary>
        /// This function creates the dc dropdown list to select different dc features
        /// </summary>
        try {
            
            let obj = me.vcMenu.selection.entries.menu.dcFeatures;
            obj.append($("<div>").attr("id", "m-dc-features-header").addClass("vc-list-header-simple").html(me.specific.resources.options).css({ "text-align": "center", "font-weight": "normal" }));
            obj.append($("<div>").attr("id", "btn-select-dc-feature").addClass("button-toggle").css({ "display": "table", "width": "100px", "box-sizing": "border-box", "font-size": "11px" }).html("<i class='fa fa-solid fa-bars icons'></i><br/>" + me.specific.resources.selection).button());
            var currStr = obj.find("#btn-select-dc-feature").html();
            obj.find("#btn-select-dc-feature").html(currStr + "<div class='color-bg-secondary separation-line-2 icons'></div>" + "<i class='ddl-select-btn-2 fa fa-light fa-angles-down icons'></i>"); // add dropdown arrow icon
            obj.find("#btn-select-dc-feature").find(".icons").css("font-size", "16px");
            obj.find("#btn-select-dc-feature > span").css("margin-right", "20px");
            obj.menu = $("<div>").attr("id", "m-dc-features-menu").addClass("ddl-menu");

            // add all feature buttons to the dropdown menu
            obj.append($("<div>").attr("id", "btn-open-plaus").data("type", "multiplaus").addClass("button-toggle dc-feature").html("<i class='fa fa-arrows-to-dotted-line'></i><br/>" + me.specific.resources.singlePlaus));
            obj.append($("<div>").attr("id", "btn-open-fill").data("type", "singleEdit").addClass("button-toggle dc-feature").html("<i class='fa fa-terminal'></i><br/>" + me.specific.resources.fillLeaks));
            obj.append($("<div>").attr("id", "btn-open-range").data("type", "rangeEdit").addClass("button-toggle dc-feature").html("<i class='fa fa-list-ul'></i><br/>" + me.specific.resources.valueRange));
            obj.append($("<div>").attr("id", "btn-open-alarms").data("type", "alarm").addClass("button-toggle dc-feature").html("<i class='fa fa-bell'></i><br/>" + me.specific.resources.alerts));
            obj.append($("<div>").attr("id", "btn-open-state").data("type", "archiveStatus").addClass("button-toggle dc-feature").html("<i class='fa fa-braille'></i><br/>" + me.specific.resources.state));
            obj.append($("<div>").attr("id", "btn-open-tasks").data("type", "tasks").addClass("button-toggle dc-feature").html("<i class='fa fa-regular fa-paper-plane'></i><br/>" + me.specific.resources.tasks));

            obj.find(".dc-feature").addClass("margin-elements").css("height", "35px").css("font-size", "10px");
            obj.find(".dc-feature").children().css("font-size", "14px"); // set font size of button icon and text to different values
            obj.menu.append($("<div>").addClass("margin-elements menu-sep-line"));
            obj.menu.append(obj.find(".dc-feature"));
            obj.append(obj.menu);

            //format the menu and the feature buttons
            var btn = obj.find("#btn-select-dc-feature").outerWidth();
            var padd = $("#m-dc-features-header").innerWidth() - $("#m-dc-features-header").width();
            obj.find("#m-dc-features-header").width(btn - padd);
            obj.find("#m-dc-features-menu").width(btn + 2);
            obj.find(".dc-feature").width(btn);
            obj.find("#btn-select-dc-feature").css("height", "50px");

            obj.menu.hide();

        } catch (e) { me._writeErr(e); }
    },

    _initDcFilterBox: function (me) {
        /// <summary>
        /// This function creates the dc filter box
        /// </summary>
        try {

            var fVal = $("<div>").attr("id", "div-filter-val");
            var fPlaus = $("<div>").attr("id", "div-filter-plaus");
            var fAdd = $("<div>").attr("id", "div-filter-add");
            var fAC = $("<div>").attr("id", "div-filter-ac");
            var fClear = $("<div>").attr("id", "div-filter-clear");

            fVal.append($("<div>").attr("id", "btn-filter-faulty").html("<i class='fa-regular fa-thumbs-down icon-color-error'></i>").button());
            fVal.append($("<div>").data("index", "0").addClass("invalid-signal").html(me.specific.resources.iconDsInvalid).css("margin-left", "15px").button());
            fVal.append($("<div>").data("index", "1").addClass("invalid-signal").html(me.specific.resources.iconDsInplaus).button());
            fVal.append($("<div>").data("index", "2").addClass("invalid-signal").html(me.specific.resources.iconDsMissing).button());

            fVal.append($("<div>").attr("id", "btn-filter-measures").addClass("signal-type").attr("title", me.specific.resources.onlyMeasures).data("index", "0").html("<i class='fa fa-signal'></i>").css("margin-left", "15px").button());
            fVal.append($("<div>").attr("id", "btn-filter-rules").addClass("signal-type").attr("title", me.specific.resources.onlyRules).data("index", "1").html("<i class='fa fa-magic'></i>").button());

            fPlaus.append($("<div>").data("index", "0").addClass("plaus-type").attr("title", me.specific.resources.noPlausibilities).html("<i class='fa fa-ban icon-color-error'></i>").button());
            fPlaus.append($("<div>").data("index", "1").addClass("plaus-type").attr("title", me.specific.resources.singlePlaus + ": " + me.specific.resources.default).html("<i class='fa-regular fa-standard-definition icon-color-error'></i>").css("margin-left", "15px").button());
            fPlaus.append($("<div>").data("index", "2").addClass("plaus-type").attr("title", me.specific.resources.singlePlaus + ": " + me.specific.resources.shutdown).html("<i class='fa fa-power-off icon-color-error'></i>").button());
            fPlaus.append($("<div>").data("index", "3").addClass("plaus-type").attr("title", me.specific.resources.singlePlaus + ": " + me.specific.resources.alert).html("<i class='fa-regular fa-exclamation-triangle icon-color-error'></i>").button());
            fPlaus.append($("<div>").data("index", "4").addClass("plaus-type").attr("title", me.specific.resources.singlePlaus + ": " + me.specific.resources.outlier).html("<i class='fa-regular fa-check-circle icon-color-error'></i>").button());
            fPlaus.append($("<div>").data("index", "5").addClass("plaus-type").attr("title", me.specific.resources.singlePlaus + ": " + me.specific.resources.constControl).html("<i class='fa fa-heartbeat icon-color-ok'></i>").button());

            fAdd.append($("<div>").data("index", "0").data("value", 0).attr("title", me.specific.resources.actType).data("btntext", ["<i class='fa fa-plug'></i>", "<i class='fa fa-plug'></i> ! "]).addClass("add-type").html("<i class='fa fa-plug'></i>"));
            fAdd.append($("<div>").data("index", "2").data("value", 0).attr("title", me.specific.resources.sumType).data("btntext", ["<i class='fa-solid fa-sigma'></i>", "<i class='fa-solid fa-sigma'></i> ! "]).addClass("add-type").html("<i class='fa-solid fa-sigma'></i>"));
            fAdd.append($("<div>").data("index", "4").data("value", 0).attr("title", me.specific.resources.publicityType).data("btntext", ["<i class='fa-solid fa-bullhorn'></i>", "<i class='fa-solid fa-bullhorn'></i> ! "]).addClass("add-type").html("<i class='fa-solid fa-bullhorn'></i>"));
            fAdd.append($("<div>").data("index", "6").data("value", 0).attr("title", me.specific.resources.punctualType).data("btntext", ["<i class='fa-solid fa-clock'></i>", "<i class='fa-solid fa-clock'></i> ! "]).addClass("add-type").html("<i class='fa-solid fa-clock'></i>"));
            fAdd.append($("<div>").data("index", "8").data("value", 0).attr("title", me.specific.resources.importType).data("btntext", ["<i class='fa-solid fa-file-import'></i>", "<i class='fa-solid fa-file-import'></i> ! "]).addClass("add-type").html("<i class='fa-solid fa-file-import'></i>"));

            fAC.append($("<div>").data("index", "0").addClass("ac-type").attr("title", "all signals with auto check or auto edit").html(me.specific.resources.all).button());
            fAC.append($("<div>").data("index", "1").addClass("ac-type").attr("title", "all auto check signals with status ON").html("<span class='icon-color-error'>ON</span>").button());
            fAC.append($("<div>").data("index", "2").addClass("ac-type").attr("title", "all auto check signals with status OK").html("OK").button());
            fAC.append($("<div>").data("index", "3").addClass("ac-type").attr("title", "all auto check signals with status n.a.").html("n.a.").button());
            fAC.append($("<div>").data("index", "4").addClass("ac-type").attr("title", "all auto edit signals").html("AutoEdit").button());

            fClear.append($("<div>").attr("id", "btn-clear-all-filters").html(me.specific.resources.resetFilters).button());

            me.vcMenu.selection.entries.menu.dcFilterBox.vcOptionBox({
                caption: me.specific.resources.filter,
                captionWidth: 5,
                items: [
                    { button: me.specific.resources.error, clickable: true, content: fVal, width: 18 },
                    { button: me.specific.resources.singlePlaus, clickable: true, content: fPlaus, width: 25 },
                    { button: me.specific.resources.others, clickable: true, content: fAdd, width: 20 },
                    { button: "AutoCheck", clickable: true, content: fAC, width: 25 },
                    { button: "<i class='fa-regular fa-trash'></i>", clickable: true, content: fClear, width: 7 }
                ], callback: function () { }
            });

        } catch (e) { me._writeErr(e); }
    },

    _updateVisibilityOfDcArea: function (me) {
        /// <summary>
        /// updates the visibility of the dc filter boxes/buttons depending on the selected interval
        /// </summary>
        try {
            $("#s-dc-filter-box").removeClass("inactive").show();
            $("#s-btn-dc").removeClass("inactive").show();
            $("#s-dc-features").removeClass("inactive").show();

            me._updateErrorInfo();

        } catch (ex) { me._writeErr(ex); }
    },

    _toggleDcFilters: function (me) {
        /// <summary>
        /// This function handles the click events of the dc filter buttons and the activateDcBtn
        /// </summary>
        try {
            
            // we do a hack and directly load the chart clickhandler popup also in the filter section
            me.vcMenu.selection.entries.menu.dcFeatures.menu.find(".dc-feature").off("click").on("click", function () {
                var type = $(this).data("type");
                var bsaid = 0; // in this case the bsaid is not necessary, only by opening the popup directly by using the click handler
                var date = me.status.menu.startDate;

                me.chartClick.reloadNecessary = false;
                
                objChartClickHandler._openChartClickHandlerContent(me, type, bsaid, date);

                me.vcMenu.selection.entries.menu.dcFeatures.menu.hide();
                me._toggleContentOpacity();
            });

            // button click of any dc filter button regarding the plausibility type (shutdown, etc)
            me.vcMenu.selection.entries.menu.dcFilterBox.find(".plaus-type").off("click").on("click", function () {
                let obj = me.status.dcFilters.filterLists;

                // add selected filter to filter list
                $(this).toggleClass("button-toggle-active");
                obj.activePlausFilters = objDataCenter._dcFilterSelection(me, $(this), obj.activePlausFilters);

                // update text of toggle button 
                objDataCenter._updateDcFilterBoxText(me, obj.activePlausFilters);                            

                // reload the signal selection area
                me._filterAndReloadSignalSelection(true);

            }).button();

            // button click to filter all signals with any problem (invalid, unplausible, etc)
            me.vcMenu.selection.entries.menu.dcFilterBox.find("#btn-filter-faulty").off("click").on("click", function () {
                let obj = me.status.dcFilters.filterLists;

                var buttons = me.vcMenu.selection.entries.menu.dcFilterBox.find(".invalid-signal");
                var active = $(this).toggleClass("button-toggle-active").hasClass("button-toggle-active");

                $.each(buttons, function () {
                    if ($(this).data("index") < 4) {
                        $(this).toggleClass("button-toggle-active", active);
                        obj.activeValFilters = objDataCenter._dcFilterSelection(me, $(this), obj.activeValFilters);
                    }
                });

                //TODO MKU: show error tags only in archive for the moment
                /*if (me.settings.defaultChart == "archive") {*/
                    // set error tags correctly
                    objDataCenter._updateErrorTags(me);
                //}
                //else
                //    me.vcMenu.selection.treeMenu.list.vcTreeMenu2("setErrors", []);

                // update text of toggle button 
                objDataCenter._updateDcFilterBoxText(me, obj.activeValFilters);    

                // reload the signal selection area
                me._filterAndReloadSignalSelection(true);

            }).button();


            // button click of any dc filter button regarding validity (invalid, unplausible, etc) to filter selected signals
            me.vcMenu.selection.entries.menu.dcFilterBox.find(".invalid-signal").off("click").on("click", function () {
                let obj = me.status.dcFilters.filterLists;

                // add selected filter to filter list
                $(this).toggleClass("button-toggle-active");
                obj.activeValFilters = objDataCenter._dcFilterSelection(me, $(this), obj.activeValFilters);

                var buttons = me.vcMenu.selection.entries.menu.dcFilterBox.find(".invalid-signal");
                var count = 0;
                $.each(buttons, function () {
                    if ($(this).data("index") < 4 && $(this).hasClass("button-toggle-active")) {
                        count++;
                    }
                });

                if (count < 3) { me.vcMenu.selection.entries.menu.dcFilterBox.find("#btn-filter-faulty").removeClass("button-toggle-active"); }
                else if (count === 3) { me.vcMenu.selection.entries.menu.dcFilterBox.find("#btn-filter-faulty").removeClass("button-toggle-active").addClass("button-toggle-active"); }


                //TODO MKU: show error tags only in archive for the moment
                /*if (me.settings.defaultChart == "archive") {*/
                    // set error tags correctly
                    objDataCenter._updateErrorTags(me);
                //}
                //else
                //    me.vcMenu.selection.treeMenu.list.vcTreeMenu2("setErrors", []);


                // update text of toggle button 
                objDataCenter._updateDcFilterBoxText(me, obj.activeValFilters);       

                // reload the signal selection area
                me._filterAndReloadSignalSelection(true);
            });


            // button click of any dc filter button regarding the signal type (measure or rule)
            me.vcMenu.selection.entries.menu.dcFilterBox.find(".signal-type").off("click").on("click", function () {
                let obj = me.status.dcFilters.filterLists;

                // add selected filter to filter list
                $(this).toggleClass("button-toggle-active");
                obj.activeTypeFilters = objDataCenter._dcFilterSelection(me, $(this), obj.activeTypeFilters);

                // update text of toggle button 
                objDataCenter._updateDcFilterBoxText(me, obj.activeTypeFilters);

                // reload the signal selection area
                me._filterAndReloadSignalSelection(true);

            }).button();

            // button click of any dc filter button regarding type (rule, measure, etc) to filter selected signals
            me.vcMenu.selection.entries.menu.dcFilterBox.find(".add-type").off("click").on("click", function () {
                
                let obj = me.status.dcFilters.filterLists;

                $(this).removeClass("button-toggle-active");
                $(this).removeClass("button-toggle-active-red");

                // set icon of btn correctly (3 states)
                var currVal = $(this).data("value");
                var icon = $(this).data("btntext")[0];

                // check current state of the button (3 states: not enabled, default active, opposite active)
                if (currVal < 2) {
                    currVal++;
                    if (currVal === 1) { $(this).addClass("button-toggle-active"); }
                    else if (currVal === 2) {
                        $(this).addClass("button-toggle-active-red");
                        icon = $(this).data("btntext")[1];
                    }
                } else {
                    currVal = 0;
                }

                $(this).data("value", currVal);
                $(this).find("span").html(icon);

                // get all active additional filters
                obj.activeAddFilters = objDataCenter._additionalDcFilterSelection(me, $(this), obj.activeAddFilters);

                // update text of toggle button 
                objDataCenter._updateDcFilterBoxText(me, obj.activeAddFilters);  

                // reload the signal selection area
                me._filterAndReloadSignalSelection(true);

            }).button();


            // button click of any dc filter button regarding the autocheck type
            me.vcMenu.selection.entries.menu.dcFilterBox.find(".ac-type").off("click").on("click", function () {

                let obj = me.status.dcFilters.filterLists;

                // add selected filter to filter list
                $(this).toggleClass("button-toggle-active");
                obj.activeAutoCheckFilters = objDataCenter._dcFilterSelection(me, $(this), obj.activeAutoCheckFilters);

                // update text of toggle button 
                objDataCenter._updateDcFilterBoxText(me, obj.activeAutoCheckFilters);

                // reload the signal selection area
                me._filterAndReloadSignalSelection(true);

            }).button();

            me.vcMenu.selection.entries.menu.dcBtn.find("#btn-activate-dc").off("click").on("click", function () {
                if (!me.specific.DataCenterStart) { // dc btn click shall only be possible, if archive is not started from DataCenter2
                    objArchSettings._saveUserOptions(me, $(this));

                    // hide additional ds filter buttons by default; enabled during fetchDcData if dc mode is enabled
                    me.vcMenu.selection.entries.menu.dcFilter.hide();
                    me.vcMenu.selection.entries.menu.dcFeatures.hide();
                    me.vcMenu.selection.entries.menu.dcFilterBox.hide();
                    objDataCenter._fetchDcData(me);

                    // reset additional dc filtering, if dc mode is disabled
                    if (!me.status.menu.activateDataCenter) {
                        me.status.dcFilters.filterLists.activeAddFilters.length = 0;
                        me.status.dcFilters.filterLists.activePlausFilters.length = 0;
                        me.status.dcFilters.filterLists.activeAutoCheckFilters.length = 0;
                        objDataCenter._resetDcFilterBtnSelection(me);
                        me.status.signals.selectionLimit = 500;
                    }
                    else {
                        me.status.signals.selectionLimit = 100;
                    }

                    me.vcMenu.selection.entries.menu.dcFeatures.menu.hide();
                    me._toggleContentOpacity();
                }

            });

            me.vcMenu.selection.entries.menu.dcFilterBox.find("#btn-clear-all-filters").off("click").on("click", function () {
                // reset arrays with selected filters
                me.status.dcFilters.filterLists.activeTypeFilters.length = 0;
                me.status.dcFilters.filterLists.activeValFilters.length = 0;
                me.status.dcFilters.filterLists.activeAddFilters.length = 0;                
                me.status.dcFilters.filterLists.activePlausFilters.length = 0;
                me.status.dcFilters.filterLists.activeAutoCheckFilters.length = 0;

                // unselect all selected filter buttons
                objDataCenter._resetDcFilterBtnSelection(me);

                // set error tags correctly
                objDataCenter._updateErrorTags(me);

                // reload the signal selection area
                me._filterAndReloadSignalSelection(true);

            }).button();

        } catch (e) { me._writeErr(e); }
    },

    _updateDcFilterBoxText: function (me, obj) {
        /// <summary>
        /// This function updates the text in the filter box to show, how many filters are active
        /// </summary>
        try {
            var text = "";
            var amount = "";

            if (obj.length > 0)
                amount = "/" + obj.length;

            if (obj === me.status.dcFilters.filterLists.activeValFilters) {
                var lType = me.status.dcFilters.filterLists.activeTypeFilters.length;
                if (lType > 0)
                    amount = "/" + parseInt(parseInt(obj.length) + parseInt(lType));
                text = me.specific.resources.error + amount;
                me.vcMenu.selection.entries.menu.dcFilterBox.vcOptionBox("updateBtnHtml", 0, text);
            }
            else if (obj === me.status.dcFilters.filterLists.activeTypeFilters) {
                var lVal = me.status.dcFilters.filterLists.activeValFilters.length;
                if (lVal > 0)
                    amount = "/" + parseInt(parseInt(obj.length) + parseInt(lVal));
                text = me.specific.resources.error + amount;
                me.vcMenu.selection.entries.menu.dcFilterBox.vcOptionBox("updateBtnHtml", 0, text);
            }
            else if (obj === me.status.dcFilters.filterLists.activePlausFilters) {
                text = me.specific.resources.singlePlaus + amount;
                me.vcMenu.selection.entries.menu.dcFilterBox.vcOptionBox("updateBtnHtml", 1, text);
            }
            else if (obj === me.status.dcFilters.filterLists.activeAddFilters) {
                text = me.specific.resources.others + amount;
                me.vcMenu.selection.entries.menu.dcFilterBox.vcOptionBox("updateBtnHtml", 2, text);
            } 
            else if (obj === me.status.dcFilters.filterLists.activeAutoCheckFilters) {
                text = "AutoCheck" + amount;
                me.vcMenu.selection.entries.menu.dcFilterBox.vcOptionBox("updateBtnHtml", 3, text);
            } 

        } catch (e) { me._writeErr(e); } 
    },

    _additionalDcFilterSelection: function (me, obj, currFilters) {
        /// <summary>
        /// This function adds the selected additional filter to the global list of selected filters
        /// </summary>
        try {

            // get the current index and value of the selected filter button to get the correct status of the filter button
            var index = parseInt(obj.data("index"));
            var val = parseInt(obj.data("value"));
            var finalIndex = -1;

            // calculate the final index (status) of the selected filter button (3 different states)
            if (val == 1) { finalIndex = index; }
            else if (val == 2) { finalIndex = index + 1; }

            // remove current filter from filter list to ensure that selected filter is only included once in the global list
            currFilters = jQuery.grep(currFilters, function (value) {
                return value != (index + 1) && value != index;
            });

            // add newly selected filter to global list of filters
            if (val > 0) { currFilters.push(finalIndex); }

            return currFilters;

        } catch (e) { me._writeErr(e); return false; }
    },

    _dcFilterSelection: function (me, obj, currFilters) {
        /// <summary>
        /// This function adds the selected filter to the global list of selected filters
        /// </summary>
        try {
            var index = parseInt(obj.data("index"));

            // remove current filter from filter list to ensure that selected filter is only included once in the global list
            currFilters = jQuery.grep(currFilters, function (value) {
                return value != index;
            });

            // add newly selected filter to global list of filters
            if (obj.hasClass("button-toggle-active")) { currFilters.push(index); }

            return currFilters;

        } catch (e) { me._writeErr(e); return false; }
    },

    _resetDcFilterBtnSelection: function (me) {
        /// <summary>
        /// This function clears all lists of filters / problematic signals
        /// </summary>
        try {
            
            // reset button selections
            me.vcMenu.selection.entries.menu.dcFilterBox.find(".invalid-signal").removeClass("button-toggle-active");
            me.vcMenu.selection.entries.menu.dcFilterBox.find(".signal-type").removeClass("button-toggle-active");
            me.vcMenu.selection.entries.menu.dcFilterBox.find("#btn-filter-faulty").removeClass("button-toggle-active");
            me.vcMenu.selection.entries.menu.dcFilterBox.find(".plaus-type").removeClass("button-toggle-active");
            me.vcMenu.selection.entries.menu.dcFilterBox.find(".ac-type").removeClass("button-toggle-active");

            var addBtns = me.vcMenu.selection.entries.menu.dcFilterBox.find(".add-type");
            $.each(addBtns, function () {
                $(this).data("value", 0);
                $(this).removeClass("button-toggle-active");
                $(this).removeClass("button-toggle-active-red");

                var icon = $(this).data("btntext")[0];
                $(this).find("span").html(icon);
            });

            // reset dc filter box
            me.vcMenu.selection.entries.menu.dcFilterBox.vcOptionBox("updateBtnHtml", 0, me.specific.resources.error);
            me.vcMenu.selection.entries.menu.dcFilterBox.vcOptionBox("updateBtnHtml", 1, me.specific.resources.singlePlaus);
            me.vcMenu.selection.entries.menu.dcFilterBox.vcOptionBox("updateBtnHtml", 2, me.specific.resources.others);
            me.vcMenu.selection.entries.menu.dcFilterBox.vcOptionBox("updateBtnHtml", 3, "AutoCheck");
            me.vcMenu.selection.entries.menu.dcFilterBox.vcOptionBox("setIndex", 0);

            return true;

        } catch (e) { me._writeErr(e); return false; }
    },

    _applyDcFiltering: function (me, activeFilters, filteredSignals) {
        /// <summary>
        /// This function filters all already found signals if any ds filter is active (invalid, unplausible, etc)
        /// If any already found signal does not meet the ds filter criteria, the menuFilterFound class is removed again
        /// </summary>

        try {
            var currSignals = me.visual.find('#lst-signal .vc-list-item.tagFound.menuFilterFound'); // we get all already found/filtered signals

            // we remove the menuFilterFound class, if a signal is not part of the list of desired dc filters
            $.each(currSignals, function () {
                var currId = $(this).data("id");
                var included = false;

                for (var i = 0; i < activeFilters.length; i++) {
                    var obj = filteredSignals[activeFilters[i]];

                    if (obj != undefined) {
                        if (obj.includes(currId)) { // we check each already found signal, if it meets the dc filter criteria
                            included = true;
                            break;
                        }
                    }
                }

                if (!included) // if signal is not included in the list of desired dc filters, it is filtered
                    $(this).removeClass("menuFilterFound");
            });

        } catch (ex) { me._writeErr(ex);}
    },

    _clearDcFiltering: function (me) {
        /// <summary>
        /// This function clears all lists of filters / problematic signals
        /// </summary>
        try {
            me.status.dcFilters.filterLists.valFilteredSignals.length = 0;
            me.status.dcFilters.filterLists.addFilteredSignals.length = 0;
            me.status.dcFilters.filterLists.typeFilteredSignals.length = 0;


            let obj = me.status.dcFilters.validityTypes;
            obj.allInvalidSignals.length = 0;
            obj.allUnplausibleSignals.length = 0;
            obj.allMissingSignals.length = 0;

            obj = me.status.dcFilters.additionalTypes;
            obj.allInactiveSignals.length = 0;
            obj.allActiveSignals.length = 0;

        } catch (e) { me._writeErr(e); }
    },
    
    _toggleInvalidityFilters: function (me) {
        /// <summary>
        /// This function handles the click events of the invalidity filter buttons
        /// </summary>
        try {
            
            // button click to filter all signals with any problem (invalid, unplausible, etc)
            me.vcMenu.selection.entries.menu.filter.find("#btn-filter-faulty").off("click").on("click", function () {

                let obj = me.status.dcFilters.filterLists;

                var buttons = me.vcMenu.selection.entries.menu.filter.find(".invalid-signal");
                var active = $(this).toggleClass("button-toggle-active").hasClass("button-toggle-active");

                $.each(buttons, function () {
                    if ($(this).data("index") < 4) {
                        $(this).toggleClass("button-toggle-active", active);
                        obj.activeValFilters = objDataCenter._dcFilterSelection(me, $(this), obj.activeValFilters);
                    }
                });

                //TODO MKU: show error tags only in archive for the moment
                /*if (me.settings.defaultChart == "archive") {*/
                    // set error tags correctly
                    objDataCenter._updateErrorTags(me);
                //}
                //else
                //    me.vcMenu.selection.treeMenu.list.vcTreeMenu2("setErrors", []);

                // reload the signal selection area
                me._filterAndReloadSignalSelection(true);

            });


            // button click of any ds filter button regarding validity (invalid, unplausible, etc) to filter selected signals
            me.vcMenu.selection.entries.menu.filter.find(".invalid-signal").off("click").on("click", function () {
                let obj = me.status.dcFilters.filterLists;

                // add selected filter to filter list
                $(this).toggleClass("button-toggle-active");
                obj.activeValFilters = objDataCenter._dcFilterSelection(me, $(this), obj.activeValFilters);

                var buttons = me.vcMenu.selection.entries.menu.filter.find(".invalid-signal");
                var count = 0;
                $.each(buttons, function () {
                    if ($(this).data("index") < 4 && $(this).hasClass("button-toggle-active")) {
                        count++;
                    }
                });

                if (count < 4) { me.vcMenu.selection.entries.menu.filter.find("#btn-filter-faulty").removeClass("button-toggle-active"); }
                else if (count === 4) { me.vcMenu.selection.entries.menu.filter.find("#btn-filter-faulty").removeClass("button-toggle-active").addClass("button-toggle-active"); }


                //TODO MKU: show error tags only in archive for the moment
                /*if (me.settings.defaultChart == "archive") {*/
                    // set error tags correctly
                    objDataCenter._updateErrorTags(me);
                //}
                //else
                //    me.vcMenu.selection.treeMenu.list.vcTreeMenu2("setErrors", []);

                // reload the signal selection area
                me._filterAndReloadSignalSelection(true);

            });


            // button click of any ds filter button regarding type (rule, measure, etc) to filter selected signals
            me.vcMenu.selection.entries.menu.filter.find(".signal-type").off("click").on("click", function () {

                let obj = me.status.dcFilters.filterLists;

                // add selected filter to filter list
                $(this).toggleClass("button-toggle-active");
                obj.activeTypeFilters = objDataCenter._dcFilterSelection(me, $(this), obj.activeTypeFilters);

                // reload the signal selection area
                me._filterAndReloadSignalSelection(true);

            }).button();


        } catch (e) { me._writeErr(e); }
    },

    _fetchDcData: function (me) {
        /// <summary>
        /// This function fetches all data and information from the data center (errors etc)
        /// </summary>
        try {

            // get auto check info
            objDataCenter._fetchAutoCheckData(me);           
                   
            if (!me.error) {               

                me.getData({ typeid: 4, Day: me.status.menu.endDate, StartDate: me.status.menu.startDate, EndDate: me.status.menu.endDate, ChartType: me.settings.defaultChart }, function (result) {
                    if (result == null) { me.showMessage(me.resources.err_loadData, true); return true; }

                    // parse the wrapper object { HasAqsError: bool, Data: [...] }
                    var parsed = JSON.parse(result);

                    // show or hide the AQS error warning directly in the vcTreeMenu3
                    if ($('.vctree-menu-3').length > 0) {
                        me.vcMenu.selection.treeMenu.list.vcTreeMenu3("setAqsError", parsed.HasAqsError);
                    }

                    if (parsed.HasAqsError) {
                        me.status.dcFilters.allProblematicSignals = [];
                    } else {
                        me.status.dcFilters.allProblematicSignals = parsed.Data || [];
                    }

                    me.vcMenu.selection.entries.signals.find(".dc-icons").empty();

                    //TODO MKU: show error tags only in archive for the moment
                    if ((me.status.menu.activateDataCenter || me.specific.DataCenterStart) && me.settings.defaultChart == "archive") {
                        //add a data center icon to each signal
                        me.vcMenu.selection.entries.signals.find(".vc-list-item .dc-icons").html($("<i>").data("type", "DATACENTER").addClass("vc-list-icon popup fa-regular fa-laptop-medical color-font-secondary").attr("title", me.specific.resources.datacenter));
                    }

                    //we iterate all entries and create a new error list for the vcTreeMenu
                    $.each(me.status.dcFilters.allProblematicSignals, function (key, row) {
                        var signals = $.grep(me.vcMenu.selection.entries.signals.find(".vc-list-item"), function (e) { return ($(e).data("id") === row.id); });

                        if (signals.length > 0) {
                            var signal = $(signals[0]);                                                        
                            var icons = "";                            

                            // show dc icons only, if signal is not internal
                            // show dc icons only if signal is already tagged; for admin users, all signals are tagged and for each signal, error icons are shown
                            if (!row.internal) {

                                //if (!row.measure) {
                                //    if (!row.missing && row.showMissing) {
                                //        icons += me.specific.resources.iconDsNoMeasure;
                                //    }
                                //}

                                if (row.missing && row.measure && row.showMissing) {
                                    me.status.dcFilters.validityTypes.allMissingSignals.push(row.id);
                                    icons += me.specific.resources.iconDsMissing;
                                }

                                if (!row.valid && row.showInvalid) {
                                    me.status.dcFilters.validityTypes.allInvalidSignals.push(row.id);
                                    icons += me.specific.resources.iconDsInvalid;
                                }

                                if (!row.plausible && row.showUnplaus) {
                                    me.status.dcFilters.validityTypes.allUnplausibleSignals.push(row.id);
                                    icons += me.specific.resources.iconDsInplaus;
                                }


                                //TODO MKU: show error tags only in archive for the moment
                                /*if (me.settings.defaultChart == "archive") {*/
                                    signal.find(".dc-icons").append(icons);
                                /*}*/
                            }

                        }
                    });


                    //we iterate all signals and check, which signal is active
                    $.each(me.signals, function (key, row) {

                        var icons = "";

                        if (!row.internal) {
                            // get all inactive signals (measure must be explicitly false, not null/undefined for virtual signals without hardware)
                            if (row.measure === false) {
                                me.status.dcFilters.additionalTypes.allInactiveSignals.push(row.id);

                                var alreadyHandled = me.status.dcFilters.allProblematicSignals.some(function (p) { return p.id === row.id; });
                                if (!alreadyHandled) {
                                    icons += me.specific.resources.iconDsNoMeasure;
                                }
                            }
                            else {
                                me.status.dcFilters.additionalTypes.allActiveSignals.push(row.id);
                            }
                        }

                        // find the matching DOM element by row.id
                        var signals = $.grep(me.vcMenu.selection.entries.signals.find(".vc-list-item"), function (e) { return ($(e).data("id") === row.id); });
                        if (signals.length > 0) {
                            $(signals[0]).find(".dc-icons").append(icons);
                        }
                    });  

                    // add all arrays with invalid signal bsaids to the global list of filters
                    let obj = me.status.dcFilters.validityTypes;
                    // order of elements in array is important! order of added lists according to the indexes of filter buttons!
                    // e.g. invalid filter button = index 0 -> list of invalid signals needs to be added at position 0 in valFilteredSignals!
                    me.status.dcFilters.filterLists.valFilteredSignals = [obj.allInvalidSignals, obj.allUnplausibleSignals, obj.allMissingSignals];

                    obj = me.status.dcFilters.signalTypes;
                    // order of elements in array is important! order of added lists according to the indexes of filter buttons!
                    // e.g. measures filter button = index 0 -> list of measured signals needs to be added at position 0 in typeFilteredSignals!
                    me.status.dcFilters.filterLists.typeFilteredSignals = [obj.allOnlyMeasures, obj.allOnlyRules];

                    obj = me.status.dcFilters.additionalTypes;
                    me.status.dcFilters.filterLists.addFilteredSignals = [obj.allInactiveSignals, obj.allActiveSignals, obj.allSummables, obj.allNotSummables, obj.allPublics, obj.allInternals, obj.allOnTime, obj.allDelayed, obj.allImported, obj.allNotImported];

                    obj = me.status.dcFilters.plausTypes;
                    me.status.dcFilters.filterLists.plausFilteredSignals = [obj.noPlaus, obj.allStandard, obj.allShutdowns, obj.allDisturbances, obj.allOutliers, obj.allConstantControls];

                    obj = me.status.dcFilters.autoCheckTypes;
                    me.status.dcFilters.filterLists.autoCheckFilteredSignals = [obj.allACSignals, obj.allONSignals, obj.allOKSignals, obj.allNASignals, obj.allEditSignals];

                    if ((me.status.menu.activateDataCenter || me.specific.DataCenterStart) && me.status.menu.interval === 1) {
                        me.vcMenu.selection.entries.menu.dcFilter.show();
                        me.vcMenu.selection.entries.menu.dcFeatures.show();
                        me.vcMenu.selection.entries.menu.dcFilterBox.show();
                    }

                    // filter all signals regarding to the activated dc filters
                    me._filter();


                    ////TODO MKU: show error tags only in archive for the moment
                    //if (me.settings.defaultChart == "archive") {
                    //    // set error tags correctly
                    //    objDataCenter._updateErrorTags(me);
                    //}
                    //else
                    //    me.vcMenu.selection.treeMenu.list.vcTreeMenu2("setErrors", []);

                    // if archive is started via DataCenter2 and fetchDC is done for the first time, all invalidity filters shall be enabled by default 
                    if (me.specific.DataCenterStart && !me.firstDCFetchDone) 
                    {
                        me.firstDCFetchDone = true;
                        me.vcMenu.selection.entries.menu.dcFilterBox.find("#btn-filter-faulty").click();
                    }

                    // TODO MKU: disabled for the moment for new release! enable again!
                    //me.vcMenu.menu.main.button.find("#btn-reload").addClass("active").removeClass("inactive");
                    //me.vcMenu.menu.main.button.find("#btn-select").removeClass("active").removeClass("inactive").addClass("active");

                    // if archive was started via data center, we show the loading screen during switching/loading archives
                    // now everything of archive is loaded and archive content can be shown
                    if (me.specific.DataCenterStart) {
                        me.vcMenu.obj.trigger('loadingFinished', { done: true });
                        me._setHeightsWidthsOfTopMenu(me.vcMenu.menu.top.overview.list);
                    }
                    
                    return true;
                });
            }
        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _fetchAutoCheckData: function (me) {
        /// <summary>
        /// This function gets all signals with autocheck or autoedit for filtering in signal list
        /// </summary>
        try {

            // ensure that getData for AutoCheck is only called once
            if (me.isFetching) return;
            me.isFetching = true;

            me.getData({ typeid: 9 }, function (result) {   

                // reset everything before getting current auto check infos
                me.status.dcFilters.autoCheckTypes.allACSignals = [];
                me.status.dcFilters.autoCheckTypes.allONSignals = [];
                me.status.dcFilters.autoCheckTypes.allOKSignals = [];
                me.status.dcFilters.autoCheckTypes.allNASignals = [];
                me.status.dcFilters.autoCheckTypes.allEditSignals = [];

                if (result.rows != null) {
                    $.each(result.rows, function (key, row) {             
                        var signals = $.grep(me.vcMenu.selection.entries.signals.find(".vc-list-item"), function (e) { return ($(e).data("id") === row.bsaid); });
                       
                        if (signals.length > 0) {
                            var signal = $(signals[0]);
                            var info = "";
                            var sInvalid = 0;
                            var sValRule = 0;
                            var sEditRule = 0;                            

                            if (me.settings.defaultChart == "archive") {
                                // check how many valRules for this signal are already existing
                                let obj = me.status.dcFilters.autoCheckTypes;
                                sValRule = objDataCenter._countBsaidInList(obj.allACSignals, row.bsaid);
                                sValRule++;

                                // check how many active or edit rules for this signal are already existing
                                sInvalid = objDataCenter._countBsaidInList(obj.allONSignals, row.bsaid);
                                sEditRule = objDataCenter._countBsaidInList(obj.allEditSignals, row.bsaid);
                                
                                if (row.type == 1) { // all archive rules
                                    switch (row.fullState) {
                                        //case -1:
                                        //    info = "new";
                                        //    break;
                                        case 0:
                                            me.status.dcFilters.autoCheckTypes.allOKSignals.push(row.bsaid);
                                            break;
                                        case 1:                                            
                                            me.status.dcFilters.autoCheckTypes.allONSignals.push(row.bsaid);                                            
                                            sInvalid++;
                                           
                                            break;
                                        case 11: //we ignore the active state as the signal has wrong plaus or datacenter manage type
                                            //    info = "n.a.";//"<span class='state-ignored'>ON</span>";
                                            me.status.dcFilters.autoCheckTypes.allNASignals.push(row.bsaid);
                                            break;
                                        default:
                                    }
                                } else { // all edit rules
                                    me.status.dcFilters.autoCheckTypes.allEditSignals.push(row.bsaid);
                                    sEditRule++;
                                }

                                // info which is shown for each signal
                                info = sInvalid + "/" + sValRule + "-" + sEditRule; 
                                signal.find(".ac-info").empty().append(info).removeClass("auto-check icon-color-error").addClass("auto-check");  

                                if (sInvalid > 0)
                                    signal.find(".ac-info").addClass("icon-color-error").css("border", "1px solid #a00");

                                // add each signal to general autocheck list
                                me.status.dcFilters.autoCheckTypes.allACSignals.push(row.bsaid);
                            }
                        }
                    });

                }

                me.isFetching = false;

                // set filters for autocheck signals correctly
                let obj = me.status.dcFilters.autoCheckTypes;
                me.status.dcFilters.filterLists.autoCheckFilteredSignals = [obj.allACSignals, obj.allONSignals, obj.allOKSignals, obj.allNASignals, obj.allEditSignals];

                if (me.status.dcFilters.filterLists.activeAutoCheckFilters.length > 0)
                    objDataCenter._applyDcFiltering(me, me.status.dcFilters.filterLists.activeAutoCheckFilters, me.status.dcFilters.filterLists.autoCheckFilteredSignals); 

            });

        } catch (e) { me._writeErr(e); me.isFetching = false; return false; }
    },

    _countBsaidInList: function (list, bsaid) {
        try {
            return list.filter(function (b) { return b === bsaid; }).length;
        } catch (e) { me._writeErr(e); return false; }
    },    
    
    _updateErrorTags: function (me) {
        /// <summary>
        /// This function updates the error tags (number of errors) in the selection tree
        /// </summary>

        try {
            var errorTags = [];


            //we iterate all entries and create a new error list for the vcTreeMenu
            $.each(me.status.dcFilters.allProblematicSignals, function (key, row) {                

                if (!row.internal) { // errors of internal signals shall not be counted
                    
                    if (me.status.dcFilters.additionalTypes.allInactiveSignals.includes(row.id) && row.missing) // errors of inactive and missing signals shall not be counted
                        return;

                    var signals = $.grep(me.vcMenu.selection.entries.signals.find(".vc-list-item"), function (e) { return ($(e).data("id") === row.id); });

                    if (signals.length > 0) {
                        var signal = $(signals[0]);
                        var queries = [!row.valid, !row.plausible, row.missing, !row.measure];
                        var err = false;

                        if (me.status.dcFilters.filterLists.activeValFilters.length > 0) {

                            for (var i = 0; i < me.status.dcFilters.filterLists.activeValFilters.length; i++) {
                                if (queries[me.status.dcFilters.filterLists.activeValFilters[i]])
                                    err = true;
                            }

                            if (err)
                                errorTags = objDataCenter._filterErrorTags(me, errorTags, signal);

                        }
                        else
                            errorTags = objDataCenter._filterErrorTags(me, errorTags, signal);
                    }
                }
            });

            //me.vcMenu.selection.treeMenu.list.vcTreeMenu2("setErrors", errorTags);

            return true;

        }
        catch (e) { me._writeErr(e); return false; }
    },

    _filterErrorTags: function (me, errorTags, signal) {
        /// <summary>
        /// This function gets all signals with tags and errors
        /// </summary>
        try {

            //add all plain tags to the error tag list for the vcTreeMenu

            if (me.status.treeMenuId == 0) {
                //we add an error tags entry for each tag we find
                $.each(signal.data("tags").split(";;;"), function (i, e) {
                    errorTags.push(e.replace("[\\", "").split(",")[0].replace("[", ""));
                });
            } else {
                //we take the text from the col3 and remove the hidden spans and hidden fields
                var signalHw = signal.find(".col3").html();
                signalHw = signalHw.substring(0, signalHw.indexOf("<span>") - 1);
                errorTags.push(signalHw);
            }

            return errorTags;

        } catch (e) { me._writeErr(e); return false; }
    },

    _mapValIndexToErrorType: function (idx) {
        switch (idx) {
            case 1: return "inplausible";
            case 2: return "missing";
            case 0: return "invalid";
            default: return null;
        }
    },

    _getStartErrorTypeFromArchive: function (me) {
        // we get the selected error filters 
        var filters = (me.status.dcFilters && me.status.dcFilters.filterLists) ? (me.status.dcFilters.filterLists.activeValFilters || []) : [];
        if (filters.length === 1) return objDataCenter._mapValIndexToErrorType(filters[0]);

        // priority which is selected if multiple filters are active: missing > invalid > inplausible
        if (filters.includes(2)) return "missing";
        if (filters.includes(0)) return "invalid";
        if (filters.includes(1)) return "inplausible";     
        
        return "invalid"; // default
    }


};